import { useTranslation } from 'react-i18next';

import InfiniteSearchSelect from '@/components/shared/InfiniteSearchSelect';
import { SearchSelect } from '@/components/ui/daisy';
import useStaffKlassFilters from '@/data/hook/klass/useStaffKlassFilters';
import { klassesQueryKeys } from '@/data/services/querykeys';
import Klass from '@/models/Klass';
import { translateKlassName } from '@/utils/translateKlassName';

type KlassSelectProps = {
  value?: number;
  onChange: (klass: Klass | null) => void;
  className?: string;
};

export default function KlassSelect({
  value,
  onChange,
  className,
}: KlassSelectProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLessons.staff',
  });
  const filters = useStaffKlassFilters();

  return (
    <SearchSelect.Fieldset aria-label={t('klass')} className={className}>
      <InfiniteSearchSelect
        listService={klassesQueryKeys.list}
        getService={id => klassesQueryKeys.get(Number(id))}
        filters={filters}
        getOptionLabel={(klass: Klass) => translateKlassName(klass.name)}
        value={value ?? null}
        onChange={onChange}
        placeholder={t('klassPlaceholder')}
      />
    </SearchSelect.Fieldset>
  );
}
